var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBars3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.125C0 0.515625 0.46875 0 1.125 0H19.875C20.4844 0 21 0.515625 21 1.125C21 1.78125 20.4844 2.25 19.875 2.25H1.125C0.46875 2.25 0 1.78125 0 1.125ZM0 8.625C0 8.01562 0.46875 7.5 1.125 7.5H19.875C20.4844 7.5 21 8.01562 21 8.625C21 9.28125 20.4844 9.75 19.875 9.75H1.125C0.46875 9.75 0 9.28125 0 8.625ZM19.875 17.25H1.125C0.46875 17.25 0 16.7812 0 16.125C0 15.5156 0.46875 15 1.125 15H19.875C20.4844 15 21 15.5156 21 16.125C21 16.7812 20.4844 17.25 19.875 17.25Z",
    fill: "#00BC70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars3);
export default __webpack_public_path__ + "static/media/bars-3.fb6d30f7.svg";
export { ForwardRef as ReactComponent };